module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Home')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-675e521c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Hopbomb.vue
// module id = 392
// module chunks = 1